import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import EntityInformation from './components/login/entityinformation.jsx';
import EmailVerification from './components/login/emailVerification.jsx';
import PhoneVerification from './components/login/phoneVerification.jsx';
import Dashboard from './components/dashboard/dashboard.jsx';
import MyPropertiesHome from './components/myproporties/myProperties_Home.jsx';
import ReviewAndConfirm from './components/reviewConfirm/reviewandConfirm.jsx';
import ViewPrakingLotInfo from './components/reviewConfirm/viewParkingLotInfo.jsx';
import SignUP from './components/login/signUP.jsx';
import ResetPassword from './components/ResetPassword/ResetPassword.jsx';
import ForgetPassword from './components/ResetPassword/ForgetPassword.jsx';
import LocatePropertNewScreen from './components/myproporties/LocatePropertNewScreen.jsx';
import MapDashboard from './components/myproporties/MapDashboard.jsx';
import HomePage from './components/landingPage/HomePage.jsx';
import UserDelete from './components/UserDelete.jsx';
import PrivacyPolicy from './components/landingPage/components/PrivacyPolicy.jsx';
import TermsOfUse from './components/landingPage/components/TermsOfUse.jsx';
import TermsOfService from './components/landingPage/components/TermsOfService.jsx';
import UserVerify from './components/UserVerify.jsx';
import SettingEntityInfo from './components/Settings/SettingEntityInfo.jsx';
import Earnings from './components/dashboard/earnings.jsx';
import UserList from './components/UserList.jsx';
import MyWorklist from './components/MyWorklist/MyWorklist.jsx';
import ReviewTab from './components/MyWorklist/ReviewTab.jsx';
import OwnerRegistration from './components/Owner/OwnerRegistration.jsx';
import OwnerLogin from './components/Owner/OwnerLogin.jsx';
import CreatePassword from './components/Owner/CreatePasswordForOwner.jsx';
import DemoUserLogin from './components/DemoUser/DemoUserLogin.jsx';
import OwnerRegistationDashboard from './components/Owner/OwnerRegistationDashboard.jsx';
import OwnerParkinglotRegistration from './components/Owner/OwnerParkinglotRegistration.jsx';
import PendingApprovals from './components/PendingApprovals/PendingApprovals.jsx';
import GlobalSearchDashBoard from './components/GlobalSearchProperties/GlobalSearchDashBoard.jsx';
import AzureMapsFrontend from './components/SalesInsights/AzureMapsFrontend.jsx';
import FilterScreen from './components/SalesInsights/FilterScreen.jsx';
import Isochrone from './components/Isochrone/isochrone.jsx';
import MissionStatement from './components/landingPage/MissionStatement.jsx';
import { AuthInterceptor } from './components/utils/AuthInterceptor.js';
import { UserProvider } from "./components/utils/UserContext.jsx";
import PasswordSetupPage from './components/login/PasswordSetupPage.jsx';
import LoginPage from './components/login/LoginPage.jsx';
import Cookies from 'js-cookie';
import NotFoundPage from '../src/components/utils/NotFoundPage.jsx';
import GoogleMapIsochrone from './components/googlemapisochone/GoogleMapIsochrone.jsx';
import ApiDocs from './components/ApiDocs/ApiDocs.jsx'; // Import the new component
import ManagerDasboard from "./components/Employee/EmployeeDashboard.jsx";
import SystemRequirements from './components/landingPage/components/SystemRequirements.jsx';
import ProductsAndServices from "./components/landingPage/components/ProductsAndServices.jsx";
import SupportPage from './components/landingPage/components/Support.jsx';
AuthInterceptor();

const isAuthCheck = () => localStorage.getItem("isauth") === "true";

const isAuthenticated = () => {
    const token = Cookies.get("idToken");
    if (!token || token.length === 0) return false;

    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 > Date.now();
    } catch (error) {
        console.error("Error decoding token:", error);
        return false;
    }
};

// --- PRIVATE ROUTE ---
const PrivateRoute = ({ children }) => {
    if (!isAuthCheck()) {
        return <Navigate to="/" replace />;
    }
    if (!isAuthenticated()) {
        return <Navigate to="/Home" replace />;
    }
    return children;
};
// --- DEMO GUARD ---
const DemoGuard = ({ children }) => {
    const demoAuth = localStorage.getItem("demoAuth") === "true";
    return demoAuth ? children : <Navigate to="/" replace />;
};

const envname = process.env.REACT_APP_ENV_TXT || null;

const App = () => {
    return (
        <BrowserRouter>
            <UserProvider>
                <div className="App">
                    <Routes>
                        {/*Public route  */}
                        <Route path="/PasswordSetupPage" element={<PasswordSetupPage />} />

                        {/* Root route based on environment */}
                        <Route
                            path="/"
                            element={
                                envname === "Engineering" || envname === "DEMO"
                                    ? <DemoUserLogin />
                                    : <HomePage />
                            }
                        />

                        {/* All other routes */}
                        <Route
                            path="/*"
                            element={

                                (envname === "Engineering" || envname === "DEMO") ? (
                                    // Demo/Staging requires DemoGuard
                                    <DemoGuard>
                                        <Routes>
                                            <Route path="/mission-statement" element={<MissionStatement />} />
                                            <Route path="/product-and-service" element={<ProductsAndServices />} />
                                            <Route path="/login" element={<LoginPage />} />
                                            <Route path="/signup" element={<SignUP />} />
                                            <Route path="/entityinformation" element={<EntityInformation />} />
                                            <Route path="/emailVerification" element={<EmailVerification />} />
                                            <Route path="/phoneVerification" element={<PhoneVerification />} />
                                            <Route path="/ResetPassword" element={<ResetPassword />} />
                                            <Route path="/ForgetPassword" element={<ForgetPassword />} />
                                            <Route path="/isochrone" element={<Isochrone />} />
                                            <Route path="/gisochrone" element={<GoogleMapIsochrone />} />
                                            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                                            <Route path='/terms-of-use' element={<TermsOfUse />} />
                                            <Route path='/terms-of-service' element={<TermsOfService />} />
                                            <Route path='/UserVerify' element={<UserVerify />} />
                                            <Route path='/OwnerRegistration' element={<OwnerRegistration />} />
                                            <Route path='/OwnerLogin' element={<OwnerLogin />} />
                                            <Route path='/CreatePassword' element={<CreatePassword />} />
                                            <Route path='/EmployeeRegistrationDashboard' element={<PrivateRoute><ManagerDasboard /></PrivateRoute>} />
                                            <Route path='/SystemRequirements' element={<SystemRequirements />} />


                                            {/* Protected routes */}
                                            <Route path="/Home" element={<HomePage />} />
                                            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                                            <Route path="/myProperties_Home" element={<PrivateRoute><MyPropertiesHome /></PrivateRoute>} />
                                            <Route path="/locateproperty" element={<PrivateRoute><MapDashboard /></PrivateRoute>} />
                                            <Route path="/reviewandConfirm" element={<PrivateRoute><ReviewAndConfirm /></PrivateRoute>} />
                                            <Route path="/viewparkinginfo" element={<PrivateRoute><ViewPrakingLotInfo /></PrivateRoute>} />
                                            <Route path='/UserDelete' element={<PrivateRoute><UserDelete /></PrivateRoute>} />
                                            <Route path="/pendingApprovals" element={<PrivateRoute><PendingApprovals /></PrivateRoute>} />
                                            <Route path="/GlobalSearchDashBoard" element={<PrivateRoute checkCompanyEmail={true}><GlobalSearchDashBoard /></PrivateRoute>} />
                                            <Route path="/salesinsights" element={<PrivateRoute checkCompanyEmail={true}><AzureMapsFrontend /></PrivateRoute>} />
                                            <Route path='/earnings' element={<PrivateRoute><Earnings /></PrivateRoute>} />
                                            <Route path='/SettingEntityInfo' element={<PrivateRoute><SettingEntityInfo /></PrivateRoute>} />
                                            <Route path="/settings/:section" element={<PrivateRoute><SettingEntityInfo /></PrivateRoute>} />
                                            <Route path='/UserList' element={<PrivateRoute><UserList /></PrivateRoute>} />
                                            <Route path="/myworklist" element={<PrivateRoute><MyWorklist /></PrivateRoute>} />
                                            <Route path="/reviewtab" element={<PrivateRoute checkCompanyEmail={true}><ReviewTab /></PrivateRoute>} />
                                            <Route path='/OwnerRegistrationDashboard' element={<PrivateRoute><OwnerRegistationDashboard /></PrivateRoute>} />
                                            <Route path='/OwnerRegistrationDashboard/:ownerName' element={<PrivateRoute><OwnerRegistationDashboard /></PrivateRoute>} />
                                            <Route path='/OwnerParkinglotRegistration' element={<PrivateRoute><OwnerParkinglotRegistration /></PrivateRoute>} />
                                            <Route path="/filter" element={<PrivateRoute><FilterScreen /></PrivateRoute>} />
                                            <Route path="/RoboTaxi" element={<PrivateRoute><ApiDocs /></PrivateRoute>} />
                                            <Route path="/RoboTaxiV1" element={<PrivateRoute><ApiDocs /></PrivateRoute>} />
                                            <Route path='/Support' element={<SupportPage />} />
                                            <Route path="/LocatePropertNewScreen" element={<LocatePropertNewScreen />} />
                                            <Route path="*" element={<NotFoundPage />} />
                                        </Routes>
                                    </DemoGuard>
                                ) : (
                                    // Production: full functionality without DemoGuard
                                    <Routes>
                                        <Route path="/mission-statement" element={<MissionStatement />} />
                                        <Route path="/product-and-service" element={<ProductsAndServices />} />
                                        <Route path="/login" element={<LoginPage />} />
                                        {/* <Route path="/maintenancePage" element={<MaintenancePage />} /> */}
                                        <Route path="/signup" element={<SignUP />} />
                                        <Route path="/entityinformation" element={<EntityInformation />} />
                                        <Route path="/emailVerification" element={<EmailVerification />} />
                                        <Route path="/phoneVerification" element={<PhoneVerification />} />
                                        <Route path="/ResetPassword" element={<ResetPassword />} />
                                        <Route path="/ForgetPassword" element={<ForgetPassword />} />
                                        <Route path="/isochrone" element={<Isochrone />} />
                                        <Route path="/gisochrone" element={<GoogleMapIsochrone />} />
                                        <Route path="/PasswordSetupPage" element={<PasswordSetupPage />} />
                                        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                                        <Route path='/terms-of-use' element={<TermsOfUse />} />
                                        <Route path='/terms-of-service' element={<TermsOfService />} />
                                        <Route path='/UserVerify' element={<UserVerify />} />
                                        <Route path='/OwnerRegistration' element={<OwnerRegistration />} />
                                        <Route path='/OwnerLogin' element={<OwnerLogin />} />
                                        <Route path='/CreatePassword' element={<CreatePassword />} />
                                        <Route path='/SystemRequirements' element={<SystemRequirements />} />

                                        {/* Protected routes */}
                                        <Route path="/Home" element={<HomePage />} />
                                        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                                        <Route path="/myProperties_Home" element={<PrivateRoute><MyPropertiesHome /></PrivateRoute>} />
                                        <Route path="/locateproperty" element={<PrivateRoute><MapDashboard /></PrivateRoute>} />
                                        <Route path="/reviewandConfirm" element={<PrivateRoute><ReviewAndConfirm /></PrivateRoute>} />
                                        <Route path="/viewparkinginfo" element={<PrivateRoute><ViewPrakingLotInfo /></PrivateRoute>} />
                                        <Route path='/UserDelete' element={<PrivateRoute><UserDelete /></PrivateRoute>} />
                                        <Route path="/pendingApprovals" element={<PrivateRoute><PendingApprovals /></PrivateRoute>} />
                                        <Route path="/GlobalSearchDashBoard" element={<PrivateRoute checkCompanyEmail={true}><GlobalSearchDashBoard /></PrivateRoute>} />
                                        <Route path="/salesinsights" element={<PrivateRoute checkCompanyEmail={true}><AzureMapsFrontend /></PrivateRoute>} />
                                        <Route path='/EmployeeRegistrationDashboard' element={<PrivateRoute><ManagerDasboard /></PrivateRoute>} />


                                        {/* Other Routes */}
                                        <Route path="/" element={<DemoUserLogin />} />
                                        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                                        <Route path='/terms-of-use' element={<TermsOfUse />} />
                                        <Route path='/terms-of-service' element={<TermsOfService />} />
                                        <Route path='/UserVerify' element={<UserVerify />} />
                                        <Route path='/earnings' element={<PrivateRoute><Earnings /></PrivateRoute>} />
                                        <Route path='/SettingEntityInfo' element={<PrivateRoute><SettingEntityInfo /></PrivateRoute>} />
                                        <Route path="/settings/:section" element={<PrivateRoute><SettingEntityInfo /></PrivateRoute>} />
                                        <Route path='/UserList' element={<PrivateRoute><UserList /></PrivateRoute>} />
                                        <Route path="/myworklist" element={<PrivateRoute><MyWorklist /></PrivateRoute>} />
                                        <Route path="/reviewtab" element={<PrivateRoute checkCompanyEmail={true}><ReviewTab /></PrivateRoute>} />
                                        <Route path='/OwnerRegistrationDashboard' element={<PrivateRoute><OwnerRegistationDashboard /></PrivateRoute>} />
                                        <Route path='/OwnerRegistrationDashboard/:ownerName' element={<PrivateRoute><OwnerRegistationDashboard /></PrivateRoute>} />
                                        <Route path='/OwnerParkinglotRegistration' element={<PrivateRoute><OwnerParkinglotRegistration /></PrivateRoute>} />
                                        <Route path="/filter" element={<PrivateRoute><FilterScreen /></PrivateRoute>} />
                                        <Route path="/RoboTaxi" element={<PrivateRoute><ApiDocs /></PrivateRoute>} />
                                        <Route path="/RoboTaxiV1" element={<PrivateRoute><ApiDocs /></PrivateRoute>} />
                                        <Route path='/Support' element={<SupportPage />} />
                                        <Route path="/LocatePropertNewScreen" element={<LocatePropertNewScreen />} />
                                        <Route path="*" element={<NotFoundPage />} />
                                    </Routes>
                                )
                            }
                        />
                    </Routes>
                </div>
            </UserProvider>
        </BrowserRouter>
    );
};

export default App;

